/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line

export default {
  'login-page': css`
    padding: 20px;
    max-width: 512px;
    margin: auto;
    background-color: #f6f6f6;

    @media (min-width: 768px) {
      padding: auto;
      margin: auto;
    }
  `,
  'top-bar': css`
    width: 100%;
    height: 64px;
    display: flex;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -ms-flex-align: center;
    align-items: center;
    transition: all 0.3s;
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
  `,
  'site-avatar': css`
    padding: 10px 16px;
    height: 100%;
    background: #343434;
  `,
  'logo-image': css`
    height: 100%;
  `,
  'login-container': css`
    margin: auto;
  `,
  'login-panel': css`
    margin: auto;
    max-width: 260px;
    margin-top: 50px;
    text-align: center;

    @media (max-width: 468px) {
      max-width: 100%;
    }
  `,
  'login-title': css`
    font-size: 22px;
    color: #31393f;
    display: inline-block;
    margin-bottom: 30px;
  `,
  'cutting-line': css`
    font-size: 12px;
    border-top: 1px solid #e3e5e6;
    padding-top: 20px;

    > a {
      color: #293efe;
      display: inline-block;
      margin-bottom: 50px;
    }
  `,
  'login-btn': css`
    height: 36px;
    width: 100%;
    text-align: center;
    display: inline-block;
    border-radius: 2px;
    line-height: 36px;
    margin-top: 10px;
    color: #fff;
    margin-bottom: 20px;
    padding: 0;
    border: 0px;
    cursor: pointer;
    background-color: #000;
    transition: all 0.5s;

    :hover {
      background-color: #555;
      letter-spacing: 1px;
    }
    :active,
    :focus {
      background-color: #555;
    }
    .disabled {
      cursor: not-allowed;
      background-color: #888;
    }
  `,
  'form-item': css`
    position: relative;
    margin: 10px auto 20px;
    text-align: left;

    > label {
      font-size: 14px;
    }
  `,
  'form-item-input': css`
    .has-success .ant-input {
      box-shadow: none;
      background: none;
    }
    .has-error .ant-input {
      box-shadow: none;
      background: none;
    }
    .has-error .ant-form-explain {
      font-size: 12px;
    }
  `,
  'login-input': css`
    border-radius: 0;
    padding: 12px 10px;
    outline: none;
    font-size: 14px;
    border: none;
    border-bottom: 1px solid #9b9d9c;
    color: rgba(104, 114, 140, 1);
    background: none;
    box-sizing: border-box;

    :hover {
      border-color: #4365e4;
    }

    :focus {
      border: none;
      border-bottom: 1px solid #4365e4;
      box-shadow: none;
    }
  `,
}
